<template>
	<Layout>
		<div  style="width: 100%">
			<div class="index-page">
				<div data-am-widget="tabs" class="am-tabs am-tabs-default">
					<div class="am-tabs-bd">
						<div
							class="am-tab-panel am-active"
							v-if="slideshow.length > 0"
							:style="{ backgroundImage: `url(${slideshow[tabIndex].imageUrl})`}">
							<div class="index-banner">
								<div class="index-mask">
									<div class="container">
										<div class="am-g">
											<div class="am-u-md-10 am-u-sm-centered" style="text-align: center">
												<h1 class="slide_simple--title">用科技重新定义厂区拆迁与资源回收</h1>
												<p class="slide_simple--text am-text-left" style="display: flex;justify-content: center">
                          我们是一家将前沿科技与传统拆迁行业相结合的创新型企业。通过自主研发的软件技术和智能化解决方案，我们为化工厂、电厂及其他大型厂区提供高效、安全、环保的拆迁与资源回收服务。												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<ul class="am-tabs-nav am-cf index-tab">
						<li v-for="(tab,index) in tabList" :key="index" :class="tabIndex === index ? 'am-active':''" >
							<a href="#" @click.prevent="changeTab(index)">
								<div class="am-u-md-3 am-u-sm-3 am-padding-right-0">
                  <img :src="tab.img" alt="" style="width: 70px;height: 75px;" >
								</div>
								<div class="school-item-right am-u-md-9 am-u-sm-9 am-text-left " style="left: 15px">
									<strong class="promo_slider_nav--item_title">{{tab.name}}</strong>
									<p class="promo_slider_nav--item_description">{{tab.desc}}</p>
								</div>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="section" v-if="tabIndex==0">
			<div class="container" style="max-width: 1160px;">
				<div class="section--header">
					<h2 class="section--title">科技如何重新定义拆迁行业</h2>
					<p class="section--description">
            科技正在深刻改变传统行业的运作方式，拆迁行业也不例外。通过将AI、大数据、物联网等前沿技术融入拆迁与资源回收的全流程，我们不仅提升了效率，还为客户创造了更高的价值。 </p>
				</div>

				<div class="index-container">
					<div class="am-g">
						<div class="am-u-md-3" v-for="(advantage,index) in oneList" :key="index">
							<div class="features_item">
								<img :src="advantage.cover" alt=""
                     style="width: 262px; height: 196px"
                     class="responsive-image">
								<h3 class="features_item--title">{{advantage.title}}</h3>
								<p class="features_item--text">{{advantage.desc}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
			<div class="section" v-if="tabIndex==1">
			<div class="container" style="max-width: 1160px;">
				<div class="section--header">
					<h2 class="section--title">数据驱动的精准决策</h2>
					<p class="section--description">
            在拆迁项目中，评估是至关重要的第一步。我们通过科技手段实现数据化、智能化的评估流程，确保每一个决策都有据可依，帮助客户全面了解厂区状况和潜在价值。		</p>
				</div>

				<div class="index-container">
					<div class="am-g">
						<div class="am-u-md-3" v-for="(advantage,index) in twoList" :key="index">
							<div class="features_item">
								<img :src="advantage.cover" alt=""
                     style="width: 262px; height: 196px"
                     class="responsive-image">
								<h3 class="features_item--title">{{advantage.title}}</h3>
								<p class="features_item--text">{{advantage.desc}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    <div class="section" v-if="tabIndex==2">
			<div class="container" style="max-width: 1160px;">
				<div class="section--header">
					<h2 class="section--title">科技赋能的高效执行</h2>
					<p class="section--description">
            拆迁过程复杂且风险较高，但通过科技手段，我们可以将每一个环节都做到精细化管理，确保项目高效推进，同时保障安全与环保。		</p>
        </div>
				<div class="index-container">
					<div class="am-g">
						<div class="am-u-md-3" v-for="(advantage,index) in threeList" :key="index">
							<div class="features_item">
                <img :src="advantage.cover" alt=""
                     style="width: 262px; height: 196px"
                     class="responsive-image">
                <h3 class="features_item--title">{{advantage.title}}</h3>
								<p class="features_item--text">{{advantage.desc}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div><div class="section" v-if="tabIndex==3">
			<div class="container" style="max-width: 1160px;">
				<div class="section--header">
					<h2 class="section--title">资源回收的最大化利用
          </h2>
					<p class="section--description">
            有色金属的回收不仅是经济价值的体现，更是资源循环利用的重要环节。我们通过智能分拣和市场洞察，确保每一克金属都能物尽其用，为客户创造最大收益。
          </p>
				</div>

				<div class="index-container">
					<div class="am-g">
						<div class="am-u-md-3" v-for="(advantage,index) in fourList" :key="index">
							<div class="features_item">
								<img :src="advantage.cover" alt=""
                     style="width: 262px; height: 196px"
                     class="responsive-image">
								<h3 class="features_item--title">{{advantage.title}}</h3>
								<p class="features_item--text">{{advantage.desc}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from "@/components/common/Layout";
export default {
	name: "IndexView",
	components: {Layout},
	data(){
    const  ossBase = 'https://luanpu.oss-cn-beijing.aliyuncs.com';
    return{
      tabList:[
				{name:'科技引领未来', desc:'智能化拆迁与资源回收的新时代', img:require('../assets/images/index/数据大屏.png')},
				{name:'智能评估', desc:'让每一步都清晰可见', img:require('../assets/images/index/平安园区.png')},
				{name:'高效拆迁', desc:'用科技优化每一个细节', img:require('../assets/images/index/企业管理.png')},
        {name:'精准回收', desc:'让每一克金属都物尽其用', img:require('../assets/images/index/智慧建设.png')},
      ],
			tabIndex: 0,
			slideshow:[],
      oneList:[
        {id:1,cover:(`${ossBase}/jianjie/fz.jpg`),title:'传统行业的痛点与挑战',desc:'传统拆迁行业长期面临效率低下、成本高昂和环保压力等问题。复杂的厂区结构、多样化的设备分布以及难以评估的资源价值，使得项目推进困难重重。'},
        {id:2,cover:(`${ossBase}/jianjie/rgzn.png`),title:'科技赋能的核心理念',desc:'我们通过自主研发的软件系统和前沿技术（如AI、大数据、物联网等），将智能化贯穿于拆迁与资源回收的每一个环节，彻底改变了传统模式。'},
        {id:3,cover:(`${ossBase}/jianjie/wrj.jpg`),title:'科技带来的变革性提升',desc:'借助无人机扫描、智能评估和实时监控，我们大幅提升了拆迁效率，降低了人工成本，并为客户创造了更高的经济价值。'},
        {id:4,cover:(`${ossBase}/jianjie/R-C.jpg`),title:'推动行业升级',desc:'我们的目标不仅是服务客户，更是通过科技创新推动整个拆迁行业向智能化、绿色化方向发展，成为行业的标杆企业。'},
      ],
      twoList:[
				{id:1,cover:(`${ossBase}/jianjie/3D.png`),title:'无人机扫描与3D建模',desc:'使用无人机对厂区进行全面扫描，生成高精度的3D模型，帮助我们快速了解厂区结构和潜在风险点。'},
				{id:2,cover:(`${ossBase}/jianjie/ai.png`),title:'AI算法驱动的价值分析',desc:'借助AI技术，我们能够精准分析厂区内的设备分布、材料种类以及有色金属的潜在价值，为客户提供科学的评估报告。'},
				{id:3,cover:(`${ossBase}/jianjie/scdt.png`),title:'市场动态与价格预测',desc:'通过大数据平台，我们实时获取有色金属市场价格动态，结合厂区库存情况，制定最优的回收与变现策略。'},
				{id:4,cover:(`${ossBase}/jianjie/pt.png`),title:'全程透明的评估流程',desc:'所有评估数据都会被记录并共享给客户，确保每一步都清晰可见，增强客户的信任感和参与感。'},
			],threeList:[
				{id:1,cover:(`${ossBase}/jianjie/zhyy.png`),title:'智能化拆迁方案设计',desc:'根据无人机扫描和AI分析结果，我们为每个厂区量身定制最优的拆迁方案，确保资源最大化利用。'},
				{id:2,cover:(`${ossBase}/jianjie/ssjk.png`),title:'物联网设备的实时监控',desc:'在现场部署物联网设备，实时监控拆迁进度和安全隐患，确保每个环节都按计划推进。'},
				{id:3,cover:(`${ossBase}/jianjie/sjfn.png`),title:'智能设备提升操作效率',desc:'使用低噪音、低粉尘的智能设备完成复杂任务，减少人工操作的风险，同时提高整体效率。'},
				{id:4,cover:(`${ossBase}/jianjie/crm.png`),title:'数据化管理与透明沟通',desc:'所有拆迁数据实现数字化管理，客户可以通过在线平台随时查看项目进展，确保全程透明。'},
			],fourList:[
				{id:1,cover:(`${ossBase}/jianjie/aisj.png`),title:'AI视觉技术的高效分拣',desc:'借助AI视觉技术，我们能够快速识别铜、铝、锌、镍等有色金属，并对其进行精准分类，避免遗漏和误差。'},
				{id:2,cover:(`${ossBase}/jianjie/bx.png`),title:'智能物流与快速变现',desc:'回收的有色金属通过智能物流系统快速运输至销售渠道，结合市场行情实现高价值变现。'},
				{id:3,cover:(`${ossBase}/jianjie/xhly.png`),title:'资源循环利用的社会价值',desc:'将回收的资源重新投入市场，推动循环经济的发展，减少资源浪费，为社会创造更大的环保价值。'},
				{id:4,cover:(`${ossBase}/jianjie/xtcx.png`),title:'全程可追溯的回收记录',desc:'每一克金属的去向都会被完整记录，客户可以随时查询回收数据，确保资源处理过程公开透明。'},
			],
			serviceList:[
				{id:1,icon:'am-icon-diamond',title:'多页面工作',desc:'标签栏可切换，不必为了新内容而被迫跳转界面，多项工作内容并行处理'},
				{id:2,icon:'am-icon-user',title:'多页面工作',desc:'标签栏可切换，不必为了新内容而被迫跳转界面，多项工作内容并行处理'},
				{id:3,icon:'am-icon-umbrella',title:'多页面工作',desc:'标签栏可切换，不必为了新内容而被迫跳转界面，多项工作内容并行处理'},
				{id:4,icon:'am-icon-briefcase',title:'多页面工作',desc:'标签栏可切换，不必为了新内容而被迫跳转界面，多项工作内容并行处理'}
			]
		}
	},
	mounted() {
	},
	methods:{
		changeTab(index){
			this.tabIndex = index
		},

	},
}
</script>

<style scoped>
/* PC样式保持不变 */
.responsive-image {
  object-fit: cover;  /* 保持图片比例 */
}

/* 手机端适配 */
@media (max-width: 768px) {
  .responsive-image {
    width: 100% !important;     /* 宽度充满容器 */
    height: auto !important;    /* 高度自适应 */
  }
}
</style>
